import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BrokernetLanguageType } from './api/backend';
import { environment } from '@environment/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {

  http = inject(HttpClient);

  get endpoint(): string {
    return environment.bppBackend + '/i18n';
  }

  getTranslation(lang: BrokernetLanguageType): Observable<Translation> {
    return this.http.get<Translation>(`${this.endpoint}/${lang.toLowerCase()}.json`);
  }
}
